// extracted by mini-css-extract-plugin
module.exports = {"spinner":"MultiSelect_spinner__1zWQH"};